import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Fragment } from 'react'
import { Button, Alert, Card, CardBody, CardFooter, Col, DropdownItem, DropdownMenu, DropdownToggle, Media, Row, UncontrolledDropdown } from 'reactstrap';
import { findMyPaysAsManager } from '../../helpers/api/finance';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination';
import FalconCardHeader from '../common/FalconCardHeader';
import Calendar from '../common/Calendar';
import PageHeader from '../common/PageHeader';
import { Link, useParams } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import FullPagination from '../common/pagination/FullPagination';
import Filter from '../common/Filter';
import { Message, Or, PreloadState } from '../UI/preloading/PreloadState';
import { isIterableArray } from '../../helpers/utils';
import { faInfoCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ButtonIcon from '../common/ButtonIcon';
import SupportLink from '../root/support/components/SupportLink';
import classNames from 'classnames';
import useModuleBase from "../../helpers/hooks/useModuleBase";

const MyPaymentService = () => {

    const moduleBase = useModuleBase();

    const history = useHistory();
    const { condominiumId, charge } = useParams();

    const [params, setParams] = useState({ condominiumCharge: charge })

    const filter_options = [
        { value: 0, displayName: 'Todos', disabled: false },
        { value: 'pending', displayName: 'Pendientes', disabled: false },
        { value: 'approved', displayName: 'Aprobados', disabled: false },
        { value: 'refused', displayName: 'Cancelados', disabled: false },
    ];

    const {
        data,
        error,
        isLoading,
        meta,
        handler:
        { goToPage, nextPage, perPage, previousPage },
    } = useSWRFetchPagination(findMyPaysAsManager, params);

    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

    const renderItems = () => data.map((payment, i) => {
        let date = new Date(payment?.created_at);
        return <Row key={i} className={payment?.status === 'processing' ? 'border-top py-3' : payment?.status === 'canceled' ? 'alert-danger border-top py-3' : payment?.status === 'refused' ? 'alert-danger border-top py-3' : 'alert-success border-top py-3'}>
            <Col>
                <Row>
                    <Col>
                        <Row>
                            <Col xs={9} className='d-flex align-items-center'>
                                <Media>
                                    <Calendar bg='primary' month={months[date.getMonth()]} day={date.getDate()} />
                                    <Media body className="position-relative pl-3 align-self-center">
                                        <p className='mb-0'>Pago del condominio {payment?.charge?.condominium?.name}</p>
                                        <p className='mb-0'><span className='font-weight-bold'>Servicio: </span>{payment?.charge?.charge?.number_properties} propiedades</p>
                                        <p className='fs--1 mb-0 font-weight-bolder'>{payment?.status === 'processing' ? 'Pendiente' : payment?.status === 'canceled' ? 'Cancelado por propietario' : payment?.status === 'refused' ? 'Pago rechazado' : 'Aprobado'}</p>
                                    </Media>
                                </Media>
                            </Col>
                            <Col xs={3} className=' d-flex align-items-center justify-content-end'>
                                <Media>
                                    <Media body className="border-left position-relative pl-3">
                                        <p className='mb-0 font-weight-bolder'>Monto</p>
                                        <p className="fs--1 mb-0 text-600"><NumberFormat displayType='text' value={payment?.amount} thousandSeparator decimalScale={2} fixedDecimalScale prefix='$ ' /></p>
                                    </Media>
                                </Media>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className="d-sm-flex align-items-center justify-content-end">
                        <UncontrolledDropdown direction="left">
                            <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu right >
                                <Link to={{ pathname: `/dashboard/${moduleBase}/${condominiumId}/my/service/${charge}/${payment.id}`, state: { payment } }} ><DropdownItem >Ver detalles</DropdownItem></Link>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Col>
                </Row>
            </Col>
        </Row>
    });

    return (
        <Fragment>
            <PageHeader
                title={"Pagos del servicio "} titleTag="h2"
                description={'Visualiza los pagos realizados al servicio.'}
                className="mb-3" col={{ lg: 9 }}>
                <SupportLink />
            </PageHeader>

            <Card>
                <FalconCardHeader title='Pagos realizados'>
                    <Row>
                        <Filter
                            keyField='status'
                            options={filter_options}
                            selectType={setParams}
                            dateFilter={true}
                        />
                      {/*   <Col xs={'auto'}>
                            <ButtonIcon icon={faPlus} tag={Link} color="falcon-default" size="md" to={`/dashboard/${moduleBase}/${condominiumId}/my/service/${charge}/payment`}>
                                Realizar pago
                            </ButtonIcon>
                        </Col> */}
                    </Row>
                </FalconCardHeader>
                <CardBody className={classNames('fs--1', { 'pt-0 pb-0': isIterableArray(data) })}>
                    <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                        <Or value={true}>
                            {renderItems()}
                        </Or>
                        <Or value={false} cond={!!error}>
                            <Message value={false} color={'info'} className='p-3 fs--1' align='left' icon={faInfoCircle}>
                                Aún no hay pagos para mostrar.
                            </Message>
                            <Or value={true}>
                                <Alert color="danger" className="mb-0">
                                    Esta página no está disponible
                                    <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => history.goBack()}>
                                        Volver
                                    </Button>
                                </Alert>
                            </Or>
                        </Or>
                    </PreloadState>
                </CardBody>
                {isIterableArray(data) &&
                    <CardFooter className="border-top">
                        <FullPagination
                            nextPage={nextPage}
                            prevPage={previousPage}
                            goToPage={goToPage}
                            meta={meta}
                            className={'shadow-none'}
                            posText={"pagos"}
                            perPage={perPage} />
                    </CardFooter>
                }
            </Card>
        </Fragment>
    )
}

export default MyPaymentService;